import { render, staticRenderFns } from "./ResultTextEditor.vue?vue&type=template&id=2d72c487&scoped=true&"
import script from "./ResultTextEditor.vue?vue&type=script&lang=js&"
export * from "./ResultTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResultTextEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResultTextEditor.vue?vue&type=style&index=1&id=2d72c487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72c487",
  null
  
)

export default component.exports